import React, { useEffect, useMemo, useState } from 'react'
import { Header } from './header'
import { Footer } from './footer'
import { useNavigate } from 'react-router-dom'
import { listcategory, listcategorycount, listtype } from '../services/homeser'
import { AllCardsSEO } from './SEO'

export const WeddingCards = () => {
    const navigate = useNavigate();
    const [clist, setCList] = useState([]);
    const [tlist, setTlist] = useState([]);
    const [products, setProducts] = useState([]); // Your full product list
    const [sortBy, setSortBy] = useState('');

    useEffect(() => {
        listcategorycount().then((res) => {
            if (res.status) {
                setCList(res.data.category_counts);
                setProducts(res.data.products);
            }
        })

        listtype().then((res) => {
            if (res.status) {
                setTlist(res.data);
            }
        })
    }, []);
    const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(12);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [priceRange, setPriceRange] = useState({ min: 0, max: 5000 });
    const filteredProducts = useMemo(() => {
        if (!products || products.length === 0) return [];

        return products.filter(item => {
            // 1. Category Filter
            const itemCatId = String(item.product_category_id);
            const matchesCategory = selectedCategory.length === 0 ||
                selectedCategory.map(String).includes(itemCatId);
            const currentPrice =
                item.selling_price && Number(item.offer_price) > 0
                    ? Number(item.offer_price)
                    : Number(item.mrp_price);
            const matchesPrice = currentPrice >= priceRange.min &&
                currentPrice <= priceRange.max;

            // 3. Search Filter - Safe check for category name
            const categoryName = item?.product_category?.category_name || "";
            const matchesSearch = categoryName.toLowerCase().includes(searchTerm.toLowerCase());
            const matchesType = !sortBy || sortBy === 'default' || String(item.type) === String(sortBy);
            return matchesCategory && matchesPrice && matchesSearch && matchesType;
        });
    }, [products, selectedCategory, priceRange, searchTerm, sortBy]);
    // 4. PAGINATION CALCULATIONS
    const totalItems = filteredProducts.length;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    console.log(currentItems);
    return (
        <>
            <AllCardsSEO />
            <Header />
            <section className="inner-section single-banner" style={{ background: "url(" + require("../assets/images/slider/single-banner.jpg") + ") no-repeat center" }}>
                <div className="container">
                    <h2>Cards</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href='index.html'>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Cards</li>
                    </ol>
                </div>
            </section>
            <section className="inner-section shop-part">
                <div className="container">
                    <div className="row content-reverse">
                        <div className="col-lg-3">
                            <div className="shop-widget-promo">
                                <a href="#"><img src={require("../assets/images/website-tech-partner.jpg")} alt="wedding website" /></a>
                            </div>
                            <div className="shop-widget">
                                <h6 className="shop-widget-title">Filter by Price</h6>
                                <div className="shop-widget-group">
                                    <input
                                        type="number"
                                        placeholder="Min"
                                        onChange={(e) => setPriceRange({ ...priceRange, min: Number(e.target.value) })}
                                    />
                                    <input
                                        type="number"
                                        placeholder="Max"
                                        onChange={(e) => setPriceRange({ ...priceRange, max: Number(e.target.value) })}
                                    />
                                </div>
                            </div>


                            <div className="shop-widget">
                                <h6 className="shop-widget-title">Filter by Category</h6>
                                <form>
                                    <input className="shop-widget-search" type="text" placeholder="Search..." onChange={(e) => setSearchTerm(e.target.value)}></input>
                                    <ul className="shop-widget-list">
                                        {clist.map(cat => {
                                            const categoryId = cat.id || cat.product_category?.id;
                                            const isChecked = selectedCategory.includes(categoryId);
                                            return (
                                                <li key={cat}>
                                                    <div className="shop-widget-content">
                                                        <input
                                                            type="checkbox"
                                                            id={cat.id}
                                                            checked={isChecked}
                                                            onChange={() => {
                                                                setSelectedCategory(prev =>
                                                                    isChecked
                                                                        ? prev.filter(c => c != categoryId) // Remove if already there
                                                                        : [...prev, categoryId]              // Add if not there
                                                                );
                                                                setCurrentPage(1); // Reset to page 1 on filter change
                                                            }}
                                                        />
                                                        <label htmlFor={categoryId}>{cat?.product_category?.category_name}</label>
                                                    </div>
                                                    {/* Display dynamic count from your products list */}
                                                    <span className="shop-widget-number">
                                                        ({cat.total || 0})
                                                    </span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                    {/* {selectedCategory.length > 0 && ( */}
                                    <button
                                        type="button"
                                        className="shop-widget-btn"
                                        onClick={() => setSelectedCategory([])}
                                    >
                                        <i className="far fa-trash-alt"></i>
                                        <span>clear filter</span>
                                    </button>
                                    {/* )} */}
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="top-filter">
                                        <div className="filter-show">
                                            <label className="filter-label">Show :</label>
                                            <select className="form-select filter-select" onChange={(e) => setItemsPerPage(Number(e.target.value))}>
                                                <option value="12">12</option>
                                                <option value="24">24</option>
                                                <option value="36">36</option>
                                            </select>
                                        </div>


                                        <div className="filter-short">
                                            <label className="filter-label">Short by :</label>
                                            <select className="form-select filter-select" onChange={(e) => setSortBy(e.target.value)} value={sortBy}>
                                                <option selected>default</option>
                                                {tlist.map(cat => {
                                                    return (
                                                        <option value={cat.id}>{cat?.type_name}</option>
                                                    )
                                                })}
                                                {/* <option value="3">trending</option>
                                                <option value="1">featured</option>
                                                <option value="2">recommend</option> */}
                                            </select>
                                        </div>
                                        {/* <div className="filter-action">
                                            <a href='shop-3column.html' title='Three Column'><i className="fas fa-th"></i></a>
                                            <a href='shop-2column.html' title='Two Column'><i className="fas fa-th-large"></i></a>
                                            <a href='shop-1column.html' title='One Column'><i className="fas fa-th-list"></i></a>
                                        </div> */}
                                        <div className="filter-action">
                                            <a className={viewMode === 'grid' ? 'active' : ''}
                                                onClick={() => setViewMode('grid')}><i className="fas fa-th"></i></a>
                                            <a className={viewMode === 'large' ? 'active' : ''}
                                                onClick={() => setViewMode('large')}><i className="fas fa-th-large"></i></a>
                                            <a className={viewMode === 'list' ? 'active' : ''}
                                                onClick={() => setViewMode('list')}><i className="fas fa-list"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`row ${viewMode === 'list' ? 'row-cols-1' : viewMode === 'large' ? 'row-cols-2 row-cols-md-3 row-cols-lg-2' : 'row-cols-2 row-cols-md-3 row-cols-lg-4'}`}>
                                {currentItems.map((product) => (
                                    <div className="col" key={product.id}>
                                        <div className={`product-card ${viewMode === 'list' ? 'product-list' : ''}`}>
                                            <div className="product-media">
                                                <div className="product-label">
                                                    <label className={`label-text ${product.tag}`}>{product.tag}</label>
                                                </div>
                                                <a className='product-image' onClick={() => navigate('/carddetails/' + product.id)}>
                                                    <img src={product.product_images[0]} alt={product.product_name} />
                                                </a>
                                            </div>
                                            <div className="product-content">
                                                <h6 className="product-name"><a onClick={() => navigate('/carddetails/' + product.id)}>{product.product_name}</a></h6>
                                                <h6 className="product-price">
                                                    {product?.offer_price != 0 ? (
                                                        <><del>₹{product?.mrp_price}</del>
                                                            <span>₹{product?.offer_price}<small>/piece</small></span></>
                                                    ) : (
                                                        <span>₹{product?.mrp_price}<small>/piece</small></span>
                                                    )

                                                    }
                                                </h6>
                                                <button className="product-add"><span>View All</span></button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="bottom-paginate">
                                        <p className="page-info">Showing {currentItems.length} of {totalItems} Results</p>
                                        <ul className="pagination">
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <a className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>
                                                    <i className="fas fa-long-arrow-alt-left"></i>
                                                </a>
                                            </li>

                                            {[...Array(totalPages)].map((_, i) => (
                                                <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                                    <a className="page-link" onClick={() => setCurrentPage(i + 1)}>
                                                        {i + 1}
                                                    </a>
                                                </li>
                                            ))}

                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <a className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>
                                                    <i className="fas fa-long-arrow-alt-right"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="news-part">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-5 col-lg-6 col-xl-7">
                            <div className="news-text">
                                <h2>Get 20% Discount for Subscriber</h2>
                                <p>Lorem ipsum dolor consectetur adipisicing accusantium</p>
                            </div>
                        </div>
                        <div className="col-md-7 col-lg-6 col-xl-5">
                            <form className="news-form">
                                <input type="text" placeholder="Enter Your Email Address" />
                                <button><span><i className="icofont-ui-email"></i>Subscribe</span></button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            <section className="intro-part">
                <div className="container">
                    <div className="row intro-content">
                        <div className="col-sm-6 col-lg-3">
                            <div className="intro-wrap">
                                <div className="intro-icon">
                                    <i className="fas fa-truck"></i>
                                </div>
                                <div className="intro-content">
                                    <h5>free home delivery</h5>
                                    <p>Lorem ipsum dolor sit amet adipisicing elit nobis.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-3">
                            <div className="intro-wrap">
                                <div className="intro-icon">
                                    <i className="fas fa-sync-alt"></i>
                                </div>
                                <div className="intro-content">
                                    <h5>instant return policy</h5>
                                    <p>Lorem ipsum dolor sit amet adipisicing elit nobis.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-3">
                            <div className="intro-wrap">
                                <div className="intro-icon">
                                    <i className="fas fa-headset"></i>
                                </div>
                                <div className="intro-content">
                                    <h5>quick support system</h5>
                                    <p>Lorem ipsum dolor sit amet adipisicing elit nobis.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-3">
                            <div className="intro-wrap">
                                <div className="intro-icon">
                                    <i className="fas fa-lock"></i>
                                </div>
                                <div className="intro-content">
                                    <h5>secure payment way</h5>
                                    <p>Lorem ipsum dolor sit amet adipisicing elit nobis.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <Footer />
        </>
    )
}